/**
 * The first path segment of every landlord screen.
 *
 * The landlord routes are only mounted while somebody is signed in (a splat
 * that matched for everyone would turn every mistyped public URL into a login
 * prompt). The cost showed up when a session ended on a page that was still
 * open: the screen was un-mounted, the address, say /tenants/<id>, matched
 * nothing, and the visitor was told "We could not find that page" for a page
 * that exists. An address that starts with one of these belongs to the app, so
 * signed out it means "sign in first", not "no such page".
 *
 * tests/appredirect.test.ts reads AppRoutes.tsx and fails if a screen is added
 * there without being listed here.
 */
export const APP_ROOTS: ReadonlySet<string> = new Set([
  'agreements', 'alerts', 'applications', 'appointments', 'arrears', 'calendar',
  'credit-notes', 'dashboard', 'data', 'deposits', 'documents', 'expenses', 'insights',
  'inspections', 'invoices', 'leases', 'listing-bundles', 'listings',
  'maintenance', 'messages', 'more', 'operations', 'owners', 'payments',
  'properties', 'receipts', 'rent', 'reports', 'sale-demand', 'sale-enquiries',
  'sale-listings', 'sale-packages', 'settings', 'tenancies', 'tenants', 'units',
  'utilities', 'vacancies',
]);

export const isAppPath = (pathname: string): boolean =>
  APP_ROOTS.has(pathname.split('/')[1] ?? '');
